module.exports = __webpack_public_path__ + "img/news-image-review3.1346886c.png";